import React, { useContext, useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ActivityLayout,
  ActivityTimer,
  ActivityProgress,
  useActivityData,
  activityApiService,
  formatTime,
  generateRemarks
} from "../shared";
import { UserContext } from "../../UserContext";
import { fetchActivitiesImage } from "../fetchActivitiesImage";
import "./MentalActivity.css";
import MentalImage from "./mental-activity-new.png";
import PlayImage from "./play-new.png";
import GoodImage from "./good.png";
import CrossImage from "./incorrect.png";
import FinishedImage from "./finished.jpeg";
// import AdminNav from '../../Navbars/AdminNav'

const MentalActivity = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activityId = searchParams.get("activityId");

  // Use shared activity data hook
  const {
    actualQuestions,
    currQuestion,
    count,
    totalQuestions,
    marksPerQuestion,
    totalMarks,
    questionNumber,
    gainedMarks,
    items,
    studentId,
    setCount,
    setQuestionNumber,
    setCurrQuestion,
    setMarksPerQuestion,
    setItems,
    setGainedMarks,
    countRef,
    totalQuestionsRef,
    progressIncrement,
    questionNumberRef,
    progressCount,
    gainedMarksRef,
    totalTimeTakenOfAllQuestions,
    totalTimeOfAllQuestions,
    completeActivityRef
  } = useActivityData(activityId);
  // Additional state for MentalActivity specific features
  const [imageData, setImageData] = useState(null);
  const [studentAnswer, setStudentAnswer] = useState("");
  const [playButtonVisibility, setPlayButtonVisibility] = useState(true);
  const [AnzanQuestionPart, setAnzanQuestionPart] = useState();
  const [remainingBodyBgColor, setRemainingBodyBgColor] = useState("transparent");

  // Refs for MentalActivity specific elements
  const submitButton = useRef(null);
  const GoodImageRef = useRef(null);
  const CrossImageRef = useRef(null);
  const FinishedImageRef = useRef(null);
  const ProgressRef = useRef(null);
  const InputRef = useRef(null);
  const studentCurrAnswerRef = useRef(0);
  const marksObtainedCurrQuestionRef = useRef(0);
  const isCorrectRef = useRef(0);

  var intervalId;
  useEffect(() => {
    intervalId = setInterval(() => {
      countRef.current = countRef.current - 1;

      if (countRef.current == -1) {
        studentCurrAnswerRef.current = "";
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 0;

        submitStudentQuestionResponse();

        questionNumberRef.current = questionNumberRef.current + 1;
        setQuestionNumber((questionNumber) => questionNumber + 1);

        setCurrQuestion(actualQuestions[questionNumberRef.current]);

        console.log("..........Calling Fetch Image..........");
        fetchActivitiesImage(
          setImageData,
          actualQuestions[questionNumberRef.current].questionpicture
        );
        setMarksPerQuestion(actualQuestions[questionNumberRef.current].marks);
        setCount(actualQuestions[questionNumberRef.current].timealloted);
        setItems([...items, 0]);
        countRef.current =
          actualQuestions[questionNumberRef.current].timealloted;

        if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
        if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

        progressCount.current += progressIncrement.current;
        if (ProgressRef.current) ProgressRef.current.style.width = `${progressCount.current}%`;
      } else {
        setCount(countRef.current);
      }
    }, 1000);

    // Return a cleanup function to clear the interval
    return () => clearInterval(intervalId);
  }, [questionNumber, count]);

  useEffect(() => {
    if (questionNumber == totalQuestions && count == 0) {
      studentCurrAnswerRef.current = "";
      marksObtainedCurrQuestionRef.current = marksPerQuestion;
      isCorrectRef.current = 0;
      submitStudentQuestionResponse();

      setItems([...items, 0]);
      clearInterval(intervalId);

      progressCount.current += progressIncrement.current;
      if (ProgressRef.current) ProgressRef.current.style.width = `${progressCount.current}%`;

      if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
      if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";
      if (submitButton.current) submitButton.current.style.display = "none";
      if (InputRef.current) InputRef.current.style.display = "none";
      if (FinishedImageRef.current) FinishedImageRef.current.style.display = "inline-block";
    }
  }, [questionNumber, count]);

  const submitStudentQuestionResponse = async () => {
    totalTimeTakenOfAllQuestions.current +=
      currQuestion?.timealloted - countRef.current - 1;
    totalTimeOfAllQuestions.current += currQuestion?.timealloted;

    try {
      await activityApiService.saveActivityQuestion({
          Question_id: currQuestion?.Question_id,
        Student_id: studentId,
          timetaken: currQuestion?.timealloted - countRef.current - 1,
          StudentAnswer: studentCurrAnswerRef.current,
          MarksObtained: marksObtainedCurrQuestionRef.current,
          TotalTime: currQuestion?.timealloted,
          correct: isCorrectRef.current,
      });

      await activityApiService.saveActivity({
          Activity_id: activityId,
        Student_id: studentId,
          MarksObtained: gainedMarksRef.current,
          MarksObtainedPercentage: (gainedMarksRef.current / totalMarks) * 100,
        Remarks: generateRemarks((gainedMarksRef.current / totalMarks) * 100),
          SubmitActivityFile: "",
          TimeTaken: totalTimeTakenOfAllQuestions.current,
          TotalMarks: totalMarks,
        TotalTime: totalTimeOfAllQuestions.current < 0 ? 0 : totalTimeOfAllQuestions.current,
        Complete: 0,
      });
    } catch (error) {
      console.error('Error submitting response:', error);
    }
  };

  const submitCompleteActivityResponse = async () => {
    try {
      await activityApiService.saveActivity({
          Activity_id: activityId,
        Student_id: studentId,
          MarksObtained: gainedMarksRef.current,
          MarksObtainedPercentage: (gainedMarksRef.current / totalMarks) * 100,
        Remarks: generateRemarks((gainedMarksRef.current / totalMarks) * 100),
          SubmitActivityFile: "",
          TimeTaken: totalTimeTakenOfAllQuestions.current,
          TotalMarks: totalMarks,
          TotalTime: totalTimeOfAllQuestions.current,
          Complete: completeActivityRef.current,
      });
    } catch (error) {
      console.error('Error submitting complete activity:', error);
    }
  };

  const handleStudentAnswer = (event) => {
    setStudentAnswer(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(studentAnswer);

    if (!studentAnswer || studentAnswer.trim() === "") {
      alert("Please enter an answer before submitting!");
      return;
    }

    if (questionNumber == totalQuestions) {
      if (studentAnswer === currQuestion?.correctanswer) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = studentAnswer;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else {
        setItems([...items, 0]);
        if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
        if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = studentAnswer;
        marksObtainedCurrQuestionRef.current = 0;
        isCorrectRef.current = 0;

        submitStudentQuestionResponse();
      }
      clearInterval(intervalId);
      if (submitButton.current) submitButton.current.style.display = "none";
      if (FinishedImageRef.current) FinishedImageRef.current.style.display = "inline-block";

      progressCount.current += progressIncrement.current;
      if (ProgressRef.current) ProgressRef.current.style.width = `${progressCount.current}%`;

      completeActivityRef.current = 1;
      submitCompleteActivityResponse();
    } else {
      if (studentAnswer == currQuestion?.correctanswer) {
        items.push(1);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = studentAnswer;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else {
        items.push(0);
        if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
        if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = studentAnswer;
        marksObtainedCurrQuestionRef.current = 0;
        isCorrectRef.current = 0;

        submitStudentQuestionResponse();
      }

      questionNumberRef.current = questionNumberRef.current + 1;
      setQuestionNumber((questionNumber) => questionNumber + 1);
      // setCurrentQuestion(questions[questionNumberRef.current]);
      setCurrQuestion(actualQuestions[questionNumberRef.current]);

      console.log("..........Calling Fetch Image..........");
      fetchActivitiesImage(
        setImageData,
        actualQuestions[questionNumberRef.current].questionpicture
      );
      setMarksPerQuestion(actualQuestions[questionNumberRef.current].marks);

      setCount(actualQuestions[questionNumberRef.current].timealloted);
      countRef.current = actualQuestions[questionNumberRef.current].timealloted;

      progressCount.current += progressIncrement.current;
      if (ProgressRef.current) ProgressRef.current.style.width = `${progressCount.current}%`;
    }
    setStudentAnswer("");
  };

  // const timerInterval = parseInt(process.env.REACT_APP_TIMER_INTERVAL, 1500);
  var playInterval;

  const getRandomPastelColor = () => {
    const darkColors = [
      "#1a237e", // Dark Blue
      "#1b5e20", // Dark Forest Green
      "#b71c1c", // Dark Red
      "#4a148c", // Dark Purple
      "#004d40", // Dark Teal
      "#3e2723", // Dark Brown
      "#263238", // Dark Blue Grey
      "#880e4f", // Dark Pink
      "#311b92", // Dark Indigo
      "#bf360c", // Dark Orange
      "#006064", // Dark Cyan
      "#827717", // Dark Olive
      "#ff6f00", // Dark Amber
      "#4a148c", // Dark Violet
      "#01579b", // Dark Ocean Blue
      "#33691e", // Dark Lime
      "#780116", // Dark Crimson
      "#4a1259", // Dark Magenta
      "#1a472a", // Dark British Racing Green
      "#2d132c", // Dark Plum
      "#631111", // Dark Burgundy
      "#0d47a1", // Dark Royal Blue
      "#194d19", // Dark Hunter Green
      "#4d1919", // Dark Wine
      "#2d004d", // Dark Deep Purple
    ];
    return darkColors[Math.floor(Math.random() * darkColors.length)];
  };

  const playQuestion = () => {
    setPlayButtonVisibility(false);

    var index = 0;
    const strArray = currQuestion?.question?.split(" ");
    console.log("StrArray is : ", strArray);
    setAnzanQuestionPart(strArray[index]);
    setRemainingBodyBgColor(getRandomPastelColor()); // Initial color change

    playInterval = setInterval(() => {
      setAnzanQuestionPart(strArray[index + 1]);
      setRemainingBodyBgColor(getRandomPastelColor()); // New color with each number

      index++;
      if (index >= strArray.length) {
        stopInterval();
      }
    }, 3000);

    const stopInterval = () => {
      clearInterval(playInterval);
      setPlayButtonVisibility(true);
      setRemainingBodyBgColor("transparent"); // Reset to original color
    };
  };

  //   const stopInterval = () => {
  //     clearInterval(playInterval);
  //   }


  const { userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  // Logout handler
  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    });
    navigate("/");
  };

  const handleCourseSelect = (course) => {
    console.log("Selected Course:", course);
  };
  return (
    <ActivityLayout
      title="Mental Activity"
              onLogout={onLogout}
              onCourseSelect={handleCourseSelect}
    >
      <div className="MAMheading">
        <div className="MAMactivity-image">
          <img src={MentalImage} alt="" />
        </div>

        <div className="MAMactivity-text">
          <h3>{currQuestion?.ActivityName}</h3>
        </div>
      </div>

      <div className="MAMcontainer">
        <div className="MAMbody">
          <div className="left-column">
            <div className="question-tracker">
              <p>
                Question
                <span className="question-number">#{questionNumber}</span>
              </p>
              <ActivityProgress
                current={questionNumber}
                total={totalQuestions}
                progress={(questionNumber / totalQuestions) * 100}
              />
            </div>
            <div className="mobile-timer">
              <ActivityTimer count={count} displayFormat="box" />
            </div>
            <div className="play-area">
              {AnzanQuestionPart}
              {playButtonVisibility && (
                <button className="MAMplay-question">
                  <img src={PlayImage} alt="" onClick={playQuestion} />
                </button>
              )}
              <p>Play</p>
            </div>
            <div className="MAMpicture">
              {imageData ? (
                <img src={imageData} alt="Question Image" />
              ) : (
                <p></p>
              )}
            </div>
            <div class="MAOanswer-submit">
              <input
                id="MAstudent-answer"
                class="MAOanswer"
                type="text"
                ref={InputRef}
                placeholder="Type Answer here..."
                value={studentAnswer}
                onChange={handleStudentAnswer}
                onKeyDown={(e) => {
                  console.log("e.key", e.key);
                  if (
                    e.key === "Enter" &&
                    questionNumber != totalQuestions &&
                    count != 0
                  ) {
                    handleSubmit(e);
                  }
                }}
              />
              <input
                id="MAsubmission"
                type="submit"
                ref={submitButton}
                onClick={handleSubmit}
              />
            </div>
            <div class="MAremarks">
              <div class="MAcorrect-wrong-picture">
                <img
                  id="MAremarksId"
                  src={GoodImage}
                  ref={GoodImageRef}
                  alt=""
                  style={{ width: "100px", display: "none" }}
                />
                <img
                  id="remarksId"
                  src={CrossImage}
                  ref={CrossImageRef}
                  alt=""
                  style={{ width: "100px", display: "none" }}
                />
              </div>

              <div class="MAfinished-picture">
                <img
                  id="finishedId"
                  src={FinishedImage}
                  ref={FinishedImageRef}
                  alt=""
                  style={{ width: "100px", display: "none" }}
                />
              </div>
            </div>
          </div>

          <div className="right-column">
            <div className="desktop-timer">
              <ActivityTimer count={count} displayFormat="box" />
            </div>
            {/* <div className="MAMscore"> */}

            {/* </div> */}
            <div id="MAmarks-color">
              {/* <div className="MAMscoreHeading"> */}
              <h3 className="MAMscoreHeading">Score</h3>
              <h3 className="MAMscoreHeading" style={{ display: "flex" }}>
                <span id="MAOcurrent-score">{gainedMarks}</span> /
                <span id="MAOtotal-score">{totalMarks}</span>
              </h3>
              {/* </div> */}
              {items.map((item, index) => (
                <div className="MAbox">
                  <div className="MAbox1">
                    <h3>{(index + 1).toString().padStart(2, "0")}</h3>
                  </div>
                  <div className={`MAbox2${item}`}>
                    {item === 1 ? "✓" : "✗"}
                  </div>
                </div>
              ))}
            </div>
            {currQuestion?.instructions && (
              <div className="">
                <span
                  style={{
                    color: "#b8860b",
                    fontWeight: "bold",
                    cursor: "pointer",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    display: "inline-block",
                    margin: "8px 0",
                    display: "flex"
                  }}
                  onClick={() => {
                    window.alert(currQuestion?.instructions);
                  }}
                >
                  Read instruction
                </span>
            </div>
            )}
          </div>
        </div>
      </div>
    </ActivityLayout>
  );
};

export default MentalActivity;
